import { render, staticRenderFns } from "./CoreValuesList.vue?vue&type=template&id=29310335&"
import script from "./CoreValuesList.vue?vue&type=script&lang=js&"
export * from "./CoreValuesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports